export default function HeroSection() {
  return (
    <section className="relative min-h-[80vh] md:min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20nightclub%20interior%20with%20elegant%20champagne%20bottles%20glowing%20with%20LED%20lights%20on%20a%20premium%20bar%20counter%2C%20sophisticated%20dark%20ambiance%20with%20golden%20and%20purple%20lighting%20accents%2C%20high-end%20VIP%20lounge%20atmosphere%2C%20professional%20photography%2C%20cinematic%20lighting%2C%20ultra-realistic%2C%208k%20quality%2C%20bokeh%20background%20with%20sparkling%20lights&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Luxury champagne background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 text-center pt-20 md:pt-0">
        <p className="text-base md:text-2xl text-gray-200 mb-3 md:mb-6 font-light">
          ホスト・キャバクラ・バー向け
        </p>
        <h1 className="text-3xl md:text-7xl font-bold text-white mb-6 md:mb-12 leading-tight">
          完全オーダーメイド<br />オリジナルシャンパン
        </h1>

        {/* Features */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-12 max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-purple-900/40 to-black/40 backdrop-blur-sm p-4 md:p-8 rounded-2xl border border-purple-500/30">
            <div className="w-10 h-10 md:w-16 md:h-16 mx-auto mb-2 md:mb-4 flex items-center justify-center">
              <i className="ri-price-tag-3-line text-3xl md:text-5xl text-yellow-400"></i>
            </div>
            <h3 className="text-xs md:text-lg font-semibold text-white">1本 2,750円〜<br />（税込）</h3>
          </div>
          <div className="bg-gradient-to-br from-purple-900/40 to-black/40 backdrop-blur-sm p-4 md:p-8 rounded-2xl border border-purple-500/30">
            <div className="w-10 h-10 md:w-16 md:h-16 mx-auto mb-2 md:mb-4 flex items-center justify-center">
              <i className="ri-truck-line text-3xl md:text-5xl text-yellow-400"></i>
            </div>
            <h3 className="text-xs md:text-lg font-semibold text-white">最短5営業日<br />発送</h3>
          </div>
          <div className="bg-gradient-to-br from-purple-900/40 to-black/40 backdrop-blur-sm p-4 md:p-8 rounded-2xl border border-purple-500/30">
            <div className="w-10 h-10 md:w-16 md:h-16 mx-auto mb-2 md:mb-4 flex items-center justify-center">
              <i className="ri-stack-line text-3xl md:text-5xl text-yellow-400"></i>
            </div>
            <h3 className="text-xs md:text-lg font-semibold text-white">6本から<br />注文OK</h3>
          </div>
          <div className="bg-gradient-to-br from-purple-900/40 to-black/40 backdrop-blur-sm p-4 md:p-8 rounded-2xl border border-purple-500/30">
            <div className="w-10 h-10 md:w-16 md:h-16 mx-auto mb-2 md:mb-4 flex items-center justify-center">
              <i className="ri-palette-line text-3xl md:text-5xl text-yellow-400"></i>
            </div>
            <h3 className="text-xs md:text-lg font-semibold text-white">プロデザイナーが<br />デザイン</h3>
          </div>
        </div>

        {/* CTA Button */}
        <a
          href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-[#06C755] hover:bg-[#05b34c] text-white text-base md:text-xl font-bold px-8 md:px-12 py-4 md:py-5 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-line-fill text-2xl md:text-3xl"></i>
          今すぐLINEで無料相談
        </a>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center z-10 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/60"></i>
      </div>
    </section>
  );
}
